import React, { useEffect, useRef } from 'react'
import './page.module.scss'
import Lenis from '@studio-freight/lenis';
import { useScroll } from 'framer-motion';
import Card from '../components/Card/Card.jsx';
import styles from './page.module.scss';
import { projects } from '../components/parallaxdata.js';


const Home = () => {
 const container = useRef(null);
  const { scrollYProgress } = useScroll({
    target: container,
    offset: ['start start', 'end end']
  })

  return (
    <div>
      <h2 className='statistics-heading'>Where Purpose Meets Progress</h2>
      <p className='team-desc'><b>Divisions That Make a Difference</b></p>
      <p className='team-desc'>VCNR is not just a group of companies, it's a Collection of missions.
Each of our verticals is born from a real-world need and built to create lasting change in its space, whether it's Changing the way people build, heal, grow, connect, or innovate. Together, they form a unified ecosystem held with care, driven by solutions, and committed to impact.
These are not just business units.
They are purpose, built engines of progress, 
led by teams, bound by values, and designed to shape a better tomorrow.
</p>
       <main ref={container} className={styles.main} style={{position: "relative"}}>
        <Card scrollYProgress={scrollYProgress} />
      </main>
    </div>
  )
}

export default Home
